import { IJxtFloorExceptionalClosingHoursFormContainer } from './types';
import { useFloorExceptionalClosingHoursForm } from '../../forms/FloorExceptionalClosingHours';

export const JxtFloorExceptionalClosingHoursFormContainer = ({
  floorExceptionalClosingHoursFormPreset,
  floorExceptionalClosingHoursToEdit,
  selectedBuilding,
}: IJxtFloorExceptionalClosingHoursFormContainer) => {
  const form = useFloorExceptionalClosingHoursForm(
    selectedBuilding,
    floorExceptionalClosingHoursToEdit,
    floorExceptionalClosingHoursFormPreset
  );

  return <div className="h-full max-sm:h-[calc(88vh-177px)]">{form}</div>;
};

export default JxtFloorExceptionalClosingHoursFormContainer;
